import React, { JSX } from 'react';
import BenefitsValidate from './BenefitValidate';
import Cookies from 'js-cookie';

const BenefitsValidateWrapper = ({
  content,
  loginContent,
  metadata,
  createCartCall,
  fetchOfferData,
  basicConfigUrl,
  selectedExistingOption,
  setShowBenefit,
  setLoginSuccess,
  isProdEnv
}: any): JSX.Element => {

  let authData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  authData = authData && JSON.parse(authData);
  return (
    <div>
      {content &&(
        <BenefitsValidate
          content={content?.beforeLoginBlok?.[0]}
          authData={authData}
          loginContent={loginContent}
          metadata={metadata}
          afterLoginContent={content?.afterLoginBlok?.[0]}
          createCartCall={createCartCall}
          fetchOfferData={fetchOfferData}
          extraContent={content}
          basicConfigUrl={basicConfigUrl}
          selectedExistingOption={selectedExistingOption}
          setShowBenefit={setShowBenefit}
          setLoginSuccess={setLoginSuccess}
          isProdEnv={isProdEnv}
          />
      )}
      
      </div>
  );
};

export default BenefitsValidateWrapper;
